import { fetchRetry } from '@/utils/api/fetchRetry';

/**
 * @author Alejandro
 * @param {Object} params
 * @param {number} params.seasonId
 * @return {Promise<{type: ArrayConstructor, required: boolean}|{type: Array | ArrayConstructor, required: boolean}|[{score: number[], data: string, visiting_team: number, season_id: number, home_team: number, game_id: number}, {score: number[], data: string, visiting_team: number, season_id: number, home_team: number, game_id: number}]>}
 */
export async function getGamesBySeason({ seasonId }) {
  try {
    const url = `https://8tvo5bp9ai.execute-api.us-west-2.amazonaws.com/prod/gamesBySeason/${seasonId}`;
    const response = await fetchRetry({ url: url });
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getGamesBySeasonV2({ seasonId, gameId }) {
  try {
    // url v1
    // https://iwxfzq6e2h.execute-api.us-west-2.amazonaws.com/prod/statisticsLeagueBySeason/${seasonId}/games/${gameId}
    const url = `https://iwxfzq6e2h.execute-api.us-west-2.amazonaws.com/prod/v2/statisticsLeagueBySeason/${seasonId}/games/${gameId}`;
    const { data } = await fetchRetry({ url: url });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getCurrentLiveGamePlays({ gameId }) {
  try {
    // https://2uj7ojhmt5.execute-api.us-west-2.amazonaws.com/prod/statisticsLive/{game_id}
    const url = `https://2uj7ojhmt5.execute-api.us-west-2.amazonaws.com/prod/V2/statisticsLive/${gameId}`;
    const response = await fetchRetry({ url: url });
    return response.data.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * @author Cristhian
 * @param {Object} params
 * @param {number} params.gameId
 * @return {Promise<{type: Object}},
 */
export async function getSpecialMentionsByGame({ gameId }) {
  try {
    const url = `https://55sbpmq0f5.execute-api.us-west-2.amazonaws.com/prod/specialMentions/${gameId}`;
    const response = await fetchRetry({ url: url });
    return response.data.data || [];
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function fetchGamesBySeason({ seasonId }) {
  try {
    const url = `https://8tvo5bp9ai.execute-api.us-west-2.amazonaws.com/prod/gamesBySeason/${seasonId}`;
    const response = await fetchRetry({ url: url });
    return response.data || { games: [] };
  } catch (e) {
    return Promise.reject(e);
  }
}
